module.exports = __webpack_public_path__ + "media/click.4a631e5c.mp3";